import React from "react"

import { TextField } from "components"
import classes from "./TdFormCapacity.module.scss"

const TdFormCapacity = props => {
  const { form, setForm } = props

  const handleChangeCapacity = (e) => {
    const number = e.target.value

    setForm(prev => ({
      ...prev,
      capacity: number
    }))
  }

  return (
    <div className={classes["item"]}>
      <div className={classes["title"]}>
        ظرفیت
      </div>
      
      <TextField
        min={0}
        max={100}
        numberType="int"
        inputClassName={classes["input"]}
        type="number"
        value={form.capacity}
        onChange={handleChangeCapacity}
      />
    </div>
  )
}

export default TdFormCapacity
